import * as React from 'react'

/**
 * @param {{
 *   yearOptions: string[]
 *   selectedYear: string
 *   onYearChange: (year: string) => void
 *   onExport: () => void
 *   exportDisabled?: boolean
 *   yearSelectDisabled?: boolean
 * }} props
 */
const DisplayTargetBar = ({
  yearOptions,
  selectedYear,
  onYearChange,
  onExport,
  exportDisabled = false,
  yearSelectDisabled = false
}) => {
  const hasYearOptions = yearOptions.length > 0

  return (
    <div className="securities-report-indicators__target-bar">
      <div className="securities-report-indicators__target-bar-left">
        <span className="securities-report-indicators__target-label">表示対象：</span>
        <select
          className="securities-report-indicators__year-select"
          value={hasYearOptions ? selectedYear : ''}
          onChange={(e) => onYearChange(e.target.value)}
          disabled={yearSelectDisabled || !hasYearOptions}
        >
          {hasYearOptions ? (
            yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))
          ) : (
            <option value="">—</option>
          )}
        </select>
      </div>
      <button
        type="button"
        onClick={onExport}
        className="securities-report-indicators__export-btn"
        disabled={exportDisabled}
      >
        <span>エクスポート</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="securities-report-indicators__export-icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3M5 20h14" />
        </svg>
      </button>
    </div>
  )
}

export default DisplayTargetBar
